import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import { ReferralUser } from 'src/Redux/referral-process/referralList'

import { RewardsList } from './components/RewardsDetails'
import { ReferAndEarnProgress } from './components/ReferAndEarnProgress/ReferAndEarnProgress'

const Title = styled.h2`
  font-family: 'Segoe UI';
  margin: 0;
  padding: 0;
  font-size: ${variables.fontSize28};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  border-radius: 16px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    box-shadow: none;
    border: none;
    padding: 0;
  }
`

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 40px;
  }
`

interface MainInfoProps {
  referralArtists: number
  referralList: ReferralUser[]
}

export const MainInfo: FC<MainInfoProps> = ({
  referralArtists,
  referralList,
}) => (
  <Container>
    <Title>Refer & Earn</Title>
    <InnerContainer>
      <ReferAndEarnProgress count={referralArtists || 0} />
      <RewardsList referralList={referralList} />
    </InnerContainer>
  </Container>
)
